// extracted by mini-css-extract-plugin
export default {"formSection":"PolicyCheckbox_formSection__PHtk8","checkboxText":"PolicyCheckbox_checkboxText__-u-3e","checkboxLink":"PolicyCheckbox_checkboxLink__ops++"};